/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface DeliveryPage { 
    archived?: boolean;
    bottomButtonLink?: string;
    bottomButtonText?: string;
    bottomContent?: string;
    bottomImage?: string;
    createdAt?: string;
    heroImage?: string;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    locked?: boolean;
    published?: boolean;
    readOnly?: boolean;
    restaurantsSection?: string;
    showMercatoButton?: boolean;
    showPartnerSection?: boolean;
    topContentSection?: string;
    updatedAt?: string;
    version?: number;
}
